<template>
    <div>
        <div>
            <div class="form-group">
                <label for="scan-jan">JAN</label>
                <input id="scan-jan" type="text" class="form-control" v-model="jan_cd">
            </div>

            <button class="btn btn-primary" @click="showTanpinNebikiModal()">発行</button>
        </div>

        <tanpin-nebiki-print-modal ref="tanpin-nebiki-print-modal" @publish="printTanpinNebikiLabel($event)" />
    </div>
</template>

<script>
import TanpinNebikiPrintModal from '@/components/views/alert/TanpinNebikiPrintModal.vue'

export default {
    name: 'Scan',
    components: {
        TanpinNebikiPrintModal,
    },
    data() {
        return {
            name: "scan",
            jan_cd: "",
        }
    },
    methods: {
        async showTanpinNebikiModal() {
            const companyCd = this.$store.state.setting.companyCd
            const storeCd = this.$store.state.setting.storeCd

            this.startLoading()
            const result = await this.getData2('fleqv', `/company/${companyCd}/store/${storeCd}/item/${this.jan_cd}`)
            console.log(result)
            this.stopLoading()

            this.$refs['tanpin-nebiki-print-modal'].open({
                item_cd: result.item_cd,
                item_name: result.item_name,
                std_price: result.std_price,
                zaiko_su: result.zaiko_su,
                nebiki_rate: 0,
            })
        },

        async printTanpinNebikiLabel({barcode_number, price, count}) {
            this.$store.dispatch("printer/printTanpinNebiki", {
                printerURL: this.$store.state.setting.printerURL,
                item_cd: barcode_number,
                price,
                count
            })
        },
    },
}
</script>
